/**
 * Move Offerly "Make an Offer" into the primary row (Quantity | Add to cart | Make an Offer).
 * Searches the whole product area and moves the Offerly block/button into the slot.
 */
(function () {
  var moved = false;

  function run() {
    var slot = document.querySelector('.product-information [data-offerly-slot]');
    if (!slot || moved) return;

    var buyButtons = document.querySelector('.product-information .buy-buttons-block');
    var primaryRow = document.querySelector('.product-information .product-form-buttons__primary-row');
    if (!primaryRow) return;

    function isMakeOfferText(el) {
      var t = (el.textContent || '').trim();
      return /make\s+an?\s+offer/i.test(t);
    }

    function tryMove(el) {
      if (!el || el.closest('[data-offerly-slot]')) return false;
      slot.appendChild(el);
      moved = true;
      return true;
    }

    /* 1) Next sibling of buy-buttons-block (Offerly app block) */
    if (buyButtons && buyButtons.nextElementSibling) {
      var next = buyButtons.nextElementSibling;
      if (!next.classList.contains('text-block') && !/financing/i.test(next.textContent || '')) {
        if (isMakeOfferText(next) || (next.querySelector && next.querySelector('[class*="offerly"], [id*="offerly"], button, a'))) {
          if (tryMove(next)) return;
        }
      }
    }

    /* 2) Any element in product-information containing "Make an Offer" (button or wrapper) */
    var productInfo = document.querySelector('.product-information');
    if (productInfo) {
      var candidates = productInfo.querySelectorAll('button, a, [role="button"], [class*="offerly"], [id*="offerly"]');
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (el.closest('.product-form-buttons__primary-row')) continue;
        if (!isMakeOfferText(el)) continue;
        var toMove = el.closest('[data-block-id]') || el.closest('div[class]') || el;
        if (toMove && !toMove.closest('[data-offerly-slot]') && tryMove(toMove)) return;
        if (tryMove(el)) return;
      }
    }

    /* 3) Full-document search for "Make an Offer" text node / button */
    var all = document.querySelectorAll('button, a, [role="button"], [data-offerly]');
    for (var j = 0; j < all.length; j++) {
      var node = all[j];
      if (!isMakeOfferText(node)) continue;
      if (node.closest('.product-information') && !node.closest('[data-offerly-slot]')) {
        var wrapper = node.closest('[data-block-id]') || node.closest('div') || node;
        if (wrapper && wrapper !== node && wrapper.contains(node) && !wrapper.closest('[data-offerly-slot]')) {
          if (tryMove(wrapper)) return;
        }
        if (tryMove(node)) return;
      }
    }

    /* 4) Fallback: move next sibling of buy-buttons (any non-financing block) */
    if (buyButtons && buyButtons.nextElementSibling && !moved) {
      var fallback = buyButtons.nextElementSibling;
      if (!fallback.classList.contains('text-block')) tryMove(fallback);
    }
  }

  function init() {
    run();
    setTimeout(run, 150);
    setTimeout(run, 400);
    setTimeout(run, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () { moved = false; run(); });

  var observer = new MutationObserver(function () {
    if (moved) return;
    run();
  });
  setTimeout(function () {
    var root = document.querySelector('.product-information .product-details');
    if (root) observer.observe(root, { childList: true, subtree: true });
  }, 200);
})();
